// extracted by mini-css-extract-plugin
export default {"auto":"index_auto_85Lid"};